import cloudinary from 'cloudinary-core';
import { omit, isEmpty, filter } from 'lodash';

const AUTO = 'auto';
const ASPECT_RATIO_DELIMITER = ':';

export default class CloudinaryUtil {
  static getDPR(roundDPR = true) {
    let dpr = window && window.devicePixelRatio || 1;
    if (roundDPR) {
      dpr = Math.ceil(dpr);
    }
    if (isNaN(dpr) || dpr <= 0) {
      dpr = 1;
    }

    let dprString = dpr.toString();
    if (dprString.match(/^\d+$/)) {
      dprString += '.0';
    }
    return dprString;
  }

  static swapDPR(t) {
    if (Array.isArray(t)) {
      return t.map(CloudinaryUtil.swapDPR);
    } else {
      if (t.dpr === AUTO) {
        return {...t, dpr: CloudinaryUtil.getDPR() };
      } else {
        return t;
      }
    }
  }

  static swapWidth(t, width) {
    if (!t) {
      return t;
    }
    if (Array.isArray(t)) {
      return t.map(ct => CloudinaryUtil.swapWidth(ct, width));
    } else {
      if (t.width === AUTO) {
        return {...t, width: width };
      } else {
        return t;
      }
    }
  }

  static changeAspectRatioToDimenssions(transformation) {
    if (!transformation) {
      return transformation;
    }

    if (Array.isArray(transformation)) {
      return transformation.map(CloudinaryUtil.changeAspectRatioToDimenssions);
    } else {
      if (transformation.aspect_ratio && transformation.aspect_ratio.includes && transformation.aspect_ratio.includes(ASPECT_RATIO_DELIMITER)) {
        let dims = transformation.aspect_ratio.split(ASPECT_RATIO_DELIMITER);
        let result = {...transformation, width: dims[0], height: dims[1] };
        return omit(result, 'aspect_ratio');
      } else {
        return {...transformation };
      }
    }
  }

  static removeDpr(transformation) {
    if (!transformation) {
      return transformation;
    }

    if (Array.isArray(transformation)) {
      return transformation.map(CloudinaryUtil.removeDpr);
    } else {
      if (transformation.dpr) {
        return omit(transformation, 'dpr');
      } else {
        return {...transformation };
      }
    }
  }

  static ensureNonEmptyTransformation(transformation) {
    if (Array.isArray(transformation)) {
      return filter(transformation, t => !isEmpty(t));
    } else {
      return transformation;
    }
  }

  static closestAbove(a, i) {
    let val;
    for (let j of a) {
      if (j > i) {
        val = j;
        break;
      }
    }
    return val;
  }

  static defaultBreakpoints() {
    let dpr = CloudinaryUtil.getDPR();
    return (width) => (Math.floor(100 * Math.ceil(width * dpr / 100) / dpr));
  }

  static breakpointFunction(breakpoints) {
    if (!breakpoints) {
      return CloudinaryUtil.defaultBreakpoints();
    } else if (Array.isArray(breakpoints)) {
      return (width) => {
        let val;
        for (let j of breakpoints) {
          if (j > width) {
            val = j;
            break;
          }
        }
        return val;
      };
    } else {
      return breakpoints;
    }
  }

}


/** WEBPACK FOOTER **
 ** ./src/js/core/CloudinaryUtil.js
 **/